/** Turn a table code like "sg-07" into a short label like "T7". Empty code = a takeaway order. */
export function formatTable(code: string): string {
  if (!code || !code.trim()) return 'Takeaway';
  const digits = code.replace(/^\w+-/, '').replace(/\D/g, '');
  const n = parseInt(digits, 10);
  return 'T' + (Number.isNaN(n) ? digits || code : n);
}
